var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService3Copy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 117,
    viewBox: "0 0 107 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.0293 84.4043C76.0293 74.4175 66.098 66.3174 53.8364 66.3174C41.5749 66.3174 31.6436 74.4175 31.6436 84.4043",
    stroke: "#FF8C40",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.836 53.0015C60.9756 53.0015 66.7634 47.2137 66.7634 40.0741C66.7634 32.9345 60.9756 27.147 53.836 27.147C46.6965 27.147 40.9087 32.9345 40.9087 40.0741C40.9087 47.2137 46.6965 53.0015 53.836 53.0015Z",
    stroke: "#FF8C40",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.214 39.5753V77.5249C104.214 83.739 100.885 89.5093 95.5032 92.6718L62.5468 111.702C57.1651 114.809 50.5072 114.809 45.0699 111.702L12.1135 92.6718C6.73176 89.5648 3.40283 83.7944 3.40283 77.5249V39.5753C3.40283 33.3613 6.73176 27.591 12.1135 24.4285L45.0699 5.39812C50.4517 2.29112 57.1096 2.29112 62.5468 5.39812L95.5032 24.4285C100.885 27.591 104.214 33.3058 104.214 39.5753Z",
    stroke: "#FF8C40",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3Copy);
export default __webpack_public_path__ + "static/media/service3 - Copy.f9d59d8032a5124519f6f8c4eb45940a.svg";
export { ForwardRef as ReactComponent };